import React from "react";
import {
  AlertNotification,
  Button,
  H2,
  Popup,
  PopupHeader,
  XIcon,
} from "@commonsku/styles";
import { BASE_ZINDEX } from "../../../popup-factory";
import styled from "styled-components";

interface PushToShopifyPopupProps {
  onClose: (popup: string) => void;
  selectedItemsWithoutVariantsCount: number;
  selectedItemCount: number;
  onPushToShopify: () => void;
}

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 10px;
  margin-bottom: 16px !important;
`;

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
`;

const PushToShopifyWarnPopup = ({
  onClose,
  selectedItemsWithoutVariantsCount,
  selectedItemCount,
  onPushToShopify,
}: PushToShopifyPopupProps) => {
  return (
    <>
      <Popup
        overlayZIndex={BASE_ZINDEX + 100}
        zIndex={BASE_ZINDEX + 200}
        style={{ width: 575, height: 224, borderRadius: 10 }}
        header={
          <PopupHeader
            style={{ padding: 0, alignItems: "center", marginBottom: 16 }}
          >
            <H2
              style={{
                fontSize: 24,
                lineHeight: "40px",
                margin: "0px",
              }}
              className="title"
            >
              Push to Shopify
            </H2>
            <XIcon
              style={{ cursor: "pointer" }}
              size="large"
              onClick={() => onClose("")}
            />
          </PopupHeader>
        }
      >
        <StyledContainer>
          <AlertNotification
            alertType={"warn"}
            style={{ height: 80, alignItems: "center" }}
          >
            {selectedItemsWithoutVariantsCount} of {selectedItemCount} selected
            products will not be pushed to Shopify. You can review them now or
            continue pushing the remaining{" "}
            {selectedItemCount - selectedItemsWithoutVariantsCount}.
          </AlertNotification>
          <ButtonContainer>
            <Button
              variant={"secondary"}
              size="medium"
              onClick={() => onClose("")}
            >
              Review Products
            </Button>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                onClose("");
                onPushToShopify();
              }}
            >
              Push {selectedItemCount - selectedItemsWithoutVariantsCount}{" "}
              Products
            </Button>
          </ButtonContainer>
        </StyledContainer>
      </Popup>
    </>
  );
};

export default PushToShopifyWarnPopup;
